export const 
  COGNITO_ERROR_NOT_AUTHORIZED_EXCEPTION = "NotAuthorizedException",
  COGNITO_ERROR_PASSWORDRESET_REQUIRED_EXCEPTION = "PasswordResetRequiredException",
  COGNITO_ERROR_USER_NOT_CONFIRMED_EXCEPTION = "UserNotConfirmedException",
  COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION =  "UserNotFoundException",
  COGNITO_ERROR_CODE_MISMATCH_EXCEPTION = "CodeMismatchException",
  COGNITO_ERROR_EXPIRED_CODE_EXCEPTION = "ExpiredCodeException",
  COGNITO_ERROR_INVALID_PARAMETER_EXCEPTION = "InvalidParameterException",
  ALREADY_VERIFIED = "ALREADY_VERIFIED",
  IS_BLOCKED = "IS_BLOCKED",
  CANT_REGEN = "CANT_REGEN",
  INVALID_EMAIL = "INVALID_EMAIL",
  PINCODE_INCORRECT = "PINCODE_INCORRECT",
  PINCODE_EXPIRED = "PINCODE_EXPIRED",
  PINCODE_NOT_FOUND = "PINCODE_NOT_FOUND",
  ACCOUNT_EXIST = "ACCOUNT_EXIST",
  SCANNED_IMAGE_NOT_PASSPORT = "E(200x015)",
  EXISTING_PASSSPORT = "W(2OFWx003)",
  CANT_CANCEL_SEA = "W(2BKGx025)"
;